import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { helpHttp } from "../../helper/helpHttp";
import * as Styled from "./ExperienciaFleischmann.styled";
import { useDispatch } from "react-redux";
import { changeLoading } from "../../redux/slices/category";
// import { BuildingPage } from "../../components/BuildingPage/BuildingPage";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";

const fleischmannV2 = {
  36: {
    title: "Panes Especiales",
  },
  38: {
    title: "Panes Enriquecidos",
    evaId: 35,
  },
  39: {
    title: "Matematica Panadera",
    evaId: 36,
  },
};

export const ExperienciaFleischmann = ({ id = 10, v2 = false, isVentas = false }) => {
  const [data, setData] = useState(undefined);
  const navigate = useNavigate();
  const { get } = helpHttp();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!id) {
      const url = window.location.href;
      id = url.split("/").at(-1);
    }

    dispatch(changeLoading(true));

    get(`categorias/getSubcategorias/${id}`)
      .then((data) => {
        setData(data.datos);
      })
      .catch(() => toast.error("Ha ocurrido un error"))
      .finally(() => {
        dispatch(changeLoading(false));
      });
  }, [id]);

  const getLinkWithVersioning = (e) => {
    const v2 = fleischmannV2[e.id];

    if (v2) {
      if (v2.evaId) {
        navigate(`/main/Expertos%20Fleischmann/${e.id}/${v2.evaId}`);
        return;
      }
      navigate(`/main/Expertos%20Fleischmann/v2/${e.id}`);
      return;
    }

    if(isVentas){
      navigate(`${e.id}`);
      return
    }
    navigate(`${e.id}`);
  };

  return (
    <Styled.GridData>
      {data?.length > 0 &&
        data.map((element) => (
          <span
            key={element.id}
            onClick={() => getLinkWithVersioning(element)}
            className="link"
          >
            <Styled.StyledCard
              estado={element.estado}
              key={element.id}
              image={element.icon || "/images/auth__bread.jpg"}
            ></Styled.StyledCard>
          </span>
        ))}
    </Styled.GridData>
  );
};
